import { render } from "./UserSocialLinks.vue?vue&type=template&id=0ef55e10&scoped=true"
import script from "./UserSocialLinks.vue?vue&type=script&lang=js"
export * from "./UserSocialLinks.vue?vue&type=script&lang=js"

import "./UserSocialLinks.vue?vue&type=style&index=0&id=0ef55e10&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ef55e10"],['__file',"src/scripts/view/portfolio/common/user/UserSocialLinks.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0ef55e10"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0ef55e10', __exports__)) {
    api.reload('0ef55e10', __exports__)
  }
  
  module.hot.accept("./UserSocialLinks.vue?vue&type=template&id=0ef55e10&scoped=true", () => {
    api.rerender('0ef55e10', render)
  })

}


export default __exports__